import React, { useState, useRef } from 'react';
import styles from './style.module.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleChevronRight } from '@fortawesome/free-solid-svg-icons';

export default function Accordion(props) {
  const { data } = props;
  const [activeList, setActiveList] = useState([true, false, false, false]);

  // handle click for header accordion
  const handleHeaderClick = (index) => {
    const newActiveList = [];

    // loop with total accordion item
    activeList.forEach((element, i) => {
      // check if this are the clicked item or not
      if (i === index) {
        // then open it
        newActiveList.push(true);
        // // then check it's opening or not
        // if (activeList[i] === false) {
        //   // if closed, open it
        //   newActiveList.push(true);
        // } else {
        //   // if opened, close it
        //   newActiveList.push(false);
        // }
      } else {
        // if not the clicked item, input "false" value
        newActiveList.push(false);
      }
    });

    // update the state value
    setActiveList(newActiveList);
  };

  return (
    <div className={styles.root}>
      {/* Loop the component based on data */}
      {data.map((data, index) => {
        return (
          <AccordionItem
            key={`accordion-${index}`}
            title={data.title}
            description={data.description}
            isActive={activeList[index]}
            icon={data.icon}
            onClick={() => handleHeaderClick(index)}
          />
        );
      })}
    </div>
  );
}

// Accordion item (single component)
const AccordionItem = (props) => {
  const { title, description, isActive, icon, onClick } = props;

  const iconRef = useRef(null);

  return (
    <div className={styles.accordionItem}>
      <div
        // if active, set "active" className
        className={`${styles.accordionHeader} ${isActive && styles.active}`}
        onClick={onClick}
        onMouseEnter={(e) => {
          iconRef.current.src = icon[0];
        }}
        // onMouseMove={(e) => {
        //   iconRef.current.src = icon[0];
        // }}
        onMouseLeave={(e) => {
          if (!isActive) iconRef.current.src = icon[1];
        }}
      >
        <div className={styles.accordionIcon}>
          <img
            src={isActive ? icon[0] : icon[1]}
            alt={`Icon from ${title}'s accordion`}
            ref={iconRef}
          />
        </div>
        <h3 className={styles.accordionTitle}>{title}</h3>
        <div className={styles.accordionArrowWrapper}>
          <FontAwesomeIcon
            // if active, set "active" className
            className={`${styles.arrow} ${isActive && styles.active}`}
            icon={faCircleChevronRight}
          />
        </div>
      </div>
      <div
        // if active, set "active" className
        className={`${styles.accordionDesc} ${isActive && styles.active}`}
      >
        <p>{description}</p>
      </div>
    </div>
  );
};
